export const LANGS: { [key: string]: string } = {
  de: 'German',
  fr: 'French',
  en: 'English',
  zh: 'Chinese',
  es: 'Spanish',
  hi: 'Hindi',
  ru: 'Russian',
  ar: 'Arabic',
  pt: 'Portuguese',
  bn: 'Bengali',
  ms: 'Malay',
  tr: 'Turkish',
  ja: 'Japanese',
  fa: 'Persian',
  ur: 'Urdu',
  pa: 'Punjabi',
  vi: 'Vietnamese',
  id: 'Indonesian',
  ko: 'Korean',
  te: 'Telugu',
  mr: 'Marathi',
  it: 'Italian',
  th: 'Thai',
  my: 'Burmese',
  kn: 'Kannada',
  gu: 'Gujarati',
  pl: 'Polish',
  af: 'Afrikaans',
  'af-NA': 'Afrikaans (Namibia)',
  'af-ZA': 'Afrikaans (South Africa)',
  agq: 'Aghem',
  'agq-CM': 'Aghem (Cameroon)',
  ak: 'Akan',
  'ak-GH': 'Akan (Ghana)',
  sq: 'Albanian',
  'sq-AL': 'Albanian (Albania)',
  am: 'Amharic',
  'am-ET': 'Amharic (Ethiopia)',
  'ar-DZ': 'Arabic (Algeria)',
  'ar-BH': 'Arabic (Bahrain)',
  'ar-EG': 'Arabic (Egypt)',
  'ar-IQ': 'Arabic (Iraq)',
  'ar-JO': 'Arabic (Jordan)',
  'ar-KW': 'Arabic (Kuwait)',
  'ar-LB': 'Arabic (Lebanon)',
  'ar-LY': 'Arabic (Libya)',
  'ar-MA': 'Arabic (Morocco)',
  'ar-OM': 'Arabic (Oman)',
  'ar-QA': 'Arabic (Qatar)',
  'ar-SA': 'Arabic (Saudi Arabia)',
  'ar-SY': 'Arabic (Syria)',
  'ar-TN': 'Arabic (Tunisia)',
  'ar-AE': 'Arabic (United Arab Emirates)',
  'ar-YE': 'Arabic (Yemen)',
  'ar-001': 'Arabic (World)',
  hy: 'Armenian',
  'hy-AM': 'Armenian (Armenia)',
  as: 'Assamese',
  'as-IN': 'Assamese (India)',
  asa: 'Asu',
  'asa-TZ': 'Asu (Tanzania)',
  az: 'Azerbaijani',
  'az-Cyrl': 'Azerbaijani (Cyrillic)',
  'az-Cyrl-AZ': 'Azerbaijani (Cyrillic, Azerbaijan)',
  'az-Latn': 'Azerbaijani (Latin)',
  'az-Latn-AZ': 'Azerbaijani (Latin, Azerbaijan)',
  ksf: 'Bafia',
  'ksf-CM': 'Bafia (Cameroon)',
  bm: 'Bambara',
  'bm-ML': 'Bambara (Mali)',
  bas: 'Basaa',
  'bas-CM': 'Basaa (Cameroon)',
  eu: 'Basque',
  'eu-ES': 'Basque (Spain)',
  be: 'Belarusian',
  'be-BY': 'Belarusian (Belarus)',
  bem: 'Bemba',
  'bem-ZM': 'Bemba (Zambia)',
  bez: 'Bena',
  'bez-TZ': 'Bena (Tanzania)',
  'bn-BD': 'Bengali (Bangladesh)',
  'bn-IN': 'Bengali (India)',
  brx: 'Bodo',
  'brx-IN': 'Bodo (India)',
  bs: 'Bosnian',
  'bs-BA': 'Bosnian (Bosnia and Herzegovina)',
  br: 'Breton',
  'br-FR': 'Breton (France)',
  bg: 'Bulgarian',
  'bg-BG': 'Bulgarian (Bulgaria)',
  'my-MM': 'Burmese (Myanmar [Burma])',
  ca: 'Catalan',
  'ca-ES': 'Catalan (Spain)',
  ckb: 'Central Kurdish',
  tzm: 'Central Morocco Tamazight',
  'tzm-Latn': 'Central Morocco Tamazight (Latin)',
  'tzm-Latn-MA': 'Central Morocco Tamazight (Latin, Morocco)',
  chr: 'Cherokee',
  'chr-US': 'Cherokee (United States)',
  cgg: 'Chiga',
  'cgg-UG': 'Chiga (Uganda)',
  'zh-CN': 'Chinese (Simplified, China)',
  'zh-Hans': 'Chinese (Simplified)',
  'zh-Hans-CN': 'Chinese (Simplified, China)',
  'zh-Hans-HK': 'Chinese (Simplified, Hong Kong SAR China)',
  'zh-Hans-MO': 'Chinese (Simplified, Macau SAR China)',
  'zh-Hans-SG': 'Chinese (Simplified, Singapore)',
  'zh-Hant': 'Chinese (Traditional)',
  'zh-Hant-HK': 'Chinese (Traditional, Hong Kong SAR China)',
  'zh-Hant-MO': 'Chinese (Traditional, Macau SAR China)',
  'zh-Hant-TW': 'Chinese (Traditional, Taiwan)',
  swc: 'Congo Swahili',
  'swc-CD': 'Congo Swahili (Congo - Kinshasa)',
  kw: 'Cornish',
  'kw-GB': 'Cornish (United Kingdom)',
  hr: 'Croatian',
  'hr-HR': 'Croatian (Croatia)',
  cs: 'Czech',
  'cs-CZ': 'Czech (Czech Republic)',
  da: 'Danish',
  'da-DK': 'Danish (Denmark)',
  dua: 'Duala',
  'dua-CM': 'Duala (Cameroon)',
  nl: 'Dutch',
  'nl-AW': 'Dutch (Aruba)',
  'nl-BE': 'Dutch (Belgium)',
  'nl-CW': 'Dutch (CuraÃ§ao)',
  'nl-NL': 'Dutch (Netherlands)',
  'nl-SX': 'Dutch (Sint Maarten)',
  ebu: 'Embu',
  'ebu-KE': 'Embu (Kenya)',
  'en-AS': 'English (American Samoa)',
  'en-AU': 'English (Australia)',
  'en-BS': 'English (Bahamas)',
  'en-BB': 'English (Barbados)',
  'en-BE': 'English (Belgium)',
  'en-BZ': 'English (Belize)',
  'en-BM': 'English (Bermuda)',
  'en-BW': 'English (Botswana)',
  'en-CA': 'English (Canada)',
  'en-EG': 'English (Egypt)',
  'en-EU': 'English (Europe)',
  'en-GU': 'English (Guam)',
  'en-GY': 'English (Guyana)',
  'en-HK': 'English (Hong Kong SAR China)',
  'en-IN': 'English (India)',
  'en-IE': 'English (Ireland)',
  'en-JM': 'English (Jamaica)',
  'en-MT': 'English (Malta)',
  'en-MH': 'English (Marshall Islands)',
  'en-MU': 'English (Mauritius)',
  'en-NA': 'English (Namibia)',
  'en-NZ': 'English (New Zealand)',
  'en-MP': 'English (Northern Mariana Islands)',
  'en-PK': 'English (Pakistan)',
  'en-PH': 'English (Philippines)',
  'en-SA': 'English (Saudi Arabia)',
  'en-SG': 'English (Singapore)',
  'en-ZA': 'English (South Africa)',
  'en-CH': 'English (Switzerland)',
  'en-TT': 'English (Trinidad and Tobago)',
  'en-UM': 'English (U.S. Minor Outlying Islands)',
  'en-VI': 'English (U.S. Virgin Islands)',
  'en-AE': 'English (U.A.E.)',
  'en-GB': 'English (United Kingdom)',
  'en-US': 'English (United States)',
  'en-ZW': 'English (Zimbabwe)',
  eo: 'Esperanto',
  et: 'Estonian',
  'et-EE': 'Estonian (Estonia)',
  ee: 'Ewe',
  'ee-GH': 'Ewe (Ghana)',
  'ee-TG': 'Ewe (Togo)',
  ewo: 'Ewondo',
  'ewo-CM': 'Ewondo (Cameroon)',
  fo: 'Faroese',
  'fo-FO': 'Faroese (Faroe Islands)',
  fil: 'Filipino',
  'fil-PH': 'Filipino (Philippines)',
  fi: 'Finnish',
  'fi-FI': 'Finnish (Finland)',
  'fr-BE': 'French (Belgium)',
  'fr-BJ': 'French (Benin)',
  'fr-BF': 'French (Burkina Faso)',
  'fr-BI': 'French (Burundi)',
  'fr-CM': 'French (Cameroon)',
  'fr-CA': 'French (Canada)',
  'fr-CF': 'French (Central African Republic)',
  'fr-TD': 'French (Chad)',
  'fr-KM': 'French (Comoros)',
  'fr-CG': 'French (Congo - Brazzaville)',
  'fr-CD': 'French (Congo - Kinshasa)',
  'fr-CI': 'French (Côte d’Ivoire)',
  'fr-DJ': 'French (Djibouti)',
  'fr-GQ': 'French (Equatorial Guinea)',
  'fr-FR': 'French (France)',
  'fr-GF': 'French (French Guiana)',
  'fr-GA': 'French (Gabon)',
  'fr-GP': 'French (Guadeloupe)',
  'fr-GN': 'French (Guinea)',
  'fr-LU': 'French (Luxembourg)',
  'fr-MG': 'French (Madagascar)',
  'fr-ML': 'French (Mali)',
  'fr-MQ': 'French (Martinique)',
  'fr-YT': 'French (Mayotte)',
  'fr-MC': 'French (Monaco)',
  'fr-NE': 'French (Niger)',
  'fr-RW': 'French (Rwanda)',
  'fr-RE': 'French (Réunion)',
  'fr-BL': 'French (Saint Barthélemy)',
  'fr-MF': 'French (Saint Martin)',
  'fr-SN': 'French (Senegal)',
  'fr-CH': 'French (Switzerland)',
  'fr-TG': 'French (Togo)',
  ff: 'Fulah',
  'ff-SN': 'Fulah (Senegal)',
  gl: 'Galician',
  'gl-ES': 'Galician (Spain)',
  lg: 'Ganda',
  'lg-UG': 'Ganda (Uganda)',
  ka: 'Georgian',
  'ka-GE': 'Georgian (Georgia)',
  'de-AT': 'German (Austria)',
  'de-BE': 'German (Belgium)',
  'de-DE': 'German (Germany)',
  'de-LI': 'German (Liechtenstein)',
  'de-LU': 'German (Luxembourg)',
  'de-CH': 'German (Switzerland)',
  el: 'Greek',
  'el-CY': 'Greek (Cyprus)',
  'el-GR': 'Greek (Greece)',
  'gu-IN': 'Gujarati (India)',
  guz: 'Gusii',
  'guz-KE': 'Gusii (Kenya)',
  ha: 'Hausa',
  'ha-Latn': 'Hausa (Latin)',
  'ha-Latn-GH': 'Hausa (Latin, Ghana)',
  'ha-Latn-NE': 'Hausa (Latin, Niger)',
  'ha-Latn-NG': 'Hausa (Latin, Nigeria)',
  haw: 'Hawaiian',
  'haw-US': 'Hawaiian (United States)',
  he: 'Hebrew',
  'he-IL': 'Hebrew (Israel)',
  'hi-IN': 'Hindi (India)',
  hu: 'Hungarian',
  'hu-HU': 'Hungarian (Hungary)',
  is: 'Icelandic',
  'is-IS': 'Icelandic (Iceland)',
  ig: 'Igbo',
  'ig-NG': 'Igbo (Nigeria)',
  'id-ID': 'Indonesian (Indonesia)',
  ga: 'Irish',
  'ga-IE': 'Irish (Ireland)',
  'it-IT': 'Italian (Italy)',
  'it-CH': 'Italian (Switzerland)',
  'ja-JP': 'Japanese (Japan)',
  dyo: 'Jola-Fonyi',
  'dyo-SN': 'Jola-Fonyi (Senegal)',
  kea: 'Kabuverdianu',
  'kea-CV': 'Kabuverdianu (Cape Verde)',
  kab: 'Kabyle',
  'kab-DZ': 'Kabyle (Algeria)',
  kl: 'Kalaallisut',
  'kl-GL': 'Kalaallisut (Greenland)',
  kln: 'Kalenjin',
  'kln-KE': 'Kalenjin (Kenya)',
  kam: 'Kamba',
  'kam-KE': 'Kamba (Kenya)',
  'kn-IN': 'Kannada (India)',
  kk: 'Kazakh',
  'kk-Cyrl': 'Kazakh (Cyrillic)',
  'kk-Cyrl-KZ': 'Kazakh (Cyrillic, Kazakhstan)',
  km: 'Khmer',
  'km-KH': 'Khmer (Cambodia)',
  ki: 'Kikuyu',
  'ki-KE': 'Kikuyu (Kenya)',
  rw: 'Kinyarwanda',
  'rw-RW': 'Kinyarwanda (Rwanda)',
  kok: 'Konkani',
  'kok-IN': 'Konkani (India)',
  'ko-KR': 'Korean (South Korea)',
  khq: 'Koyra Chiini',
  'khq-ML': 'Koyra Chiini (Mali)',
  ses: 'Koyraboro Senni',
  'ses-ML': 'Koyraboro Senni (Mali)',
  nmg: 'Kwasio',
  'nmg-CM': 'Kwasio (Cameroon)',
  lag: 'Langi',
  'lag-TZ': 'Langi (Tanzania)',
  lv: 'Latvian',
  'lv-LV': 'Latvian (Latvia)',
  ln: 'Lingala',
  'ln-CG': 'Lingala (Congo - Brazzaville)',
  'ln-CD': 'Lingala (Congo - Kinshasa)',
  lt: 'Lithuanian',
  'lt-LT': 'Lithuanian (Lithuania)',
  lu: 'Luba-Katanga',
  'lu-CD': 'Luba-Katanga (Congo - Kinshasa)',
  luo: 'Luo',
  'luo-KE': 'Luo (Kenya)',
  luy: 'Luyia',
  'luy-KE': 'Luyia (Kenya)',
  mk: 'Macedonian',
  'mk-MK': 'Macedonian (Macedonia)',
  jmc: 'Machame',
  'jmc-TZ': 'Machame (Tanzania)',
  mgh: 'Makhuwa-Meetto',
  'mgh-MZ': 'Makhuwa-Meetto (Mozambique)',
  kde: 'Makonde',
  'kde-TZ': 'Makonde (Tanzania)',
  mg: 'Malagasy',
  'mg-MG': 'Malagasy (Madagascar)',
  'ms-BN': 'Malay (Brunei)',
  'ms-MY': 'Malay (Malaysia)',
  ml: 'Malayalam',
  'ml-IN': 'Malayalam (India)',
  mt: 'Maltese',
  'mt-MT': 'Maltese (Malta)',
  gv: 'Manx',
  'gv-GB': 'Manx (United Kingdom)',
  'mr-IN': 'Marathi (India)',
  mas: 'Masai',
  'mas-KE': 'Masai (Kenya)',
  'mas-TZ': 'Masai (Tanzania)',
  mer: 'Meru',
  'mer-KE': 'Meru (Kenya)',
  mfe: 'Morisyen',
  'mfe-MU': 'Morisyen (Mauritius)',
  mua: 'Mundang',
  'mua-CM': 'Mundang (Cameroon)',
  naq: 'Nama',
  'naq-NA': 'Nama (Namibia)',
  ne: 'Nepali',
  'ne-IN': 'Nepali (India)',
  'ne-NP': 'Nepali (Nepal)',
  nd: 'North Ndebele',
  'nd-ZW': 'North Ndebele (Zimbabwe)',
  nb: 'Norwegian Bokmål',
  'nb-NO': 'Norwegian Bokmål (Norway)',
  nn: 'Norwegian Nynorsk',
  'nn-NO': 'Norwegian Nynorsk (Norway)',
  nus: 'Nuer',
  'nus-SD': 'Nuer (Sudan)',
  nyn: 'Nyankole',
  'nyn-UG': 'Nyankole (Uganda)',
  or: 'Oriya',
  'or-IN': 'Oriya (India)',
  om: 'Oromo',
  'om-ET': 'Oromo (Ethiopia)',
  'om-KE': 'Oromo (Kenya)',
  ps: 'Pashto',
  'ps-AF': 'Pashto (Afghanistan)',
  'fa-AF': 'Persian (Afghanistan)',
  'fa-IR': 'Persian (Iran)',
  'pl-PL': 'Polish (Poland)',
  'pt-AO': 'Portuguese (Angola)',
  'pt-BR': 'Portuguese (Brazil)',
  'pt-GW': 'Portuguese (Guinea-Bissau)',
  'pt-MZ': 'Portuguese (Mozambique)',
  'pt-PT': 'Portuguese (Portugal)',
  'pt-ST': 'Portuguese (São Tomé and Príncipe)',
  'pa-Arab': 'Punjabi (Arabic)',
  'pa-Arab-PK': 'Punjabi (Arabic, Pakistan)',
  'pa-Guru': 'Punjabi (Gurmukhi)',
  'pa-Guru-IN': 'Punjabi (Gurmukhi, India)',
  ro: 'Romanian',
  'ro-MD': 'Romanian (Moldova)',
  'ro-RO': 'Romanian (Romania)',
  rm: 'Romansh',
  'rm-CH': 'Romansh (Switzerland)',
  rof: 'Rombo',
  'rof-TZ': 'Rombo (Tanzania)',
  rn: 'Rundi',
  'rn-BI': 'Rundi (Burundi)',
  'ru-MD': 'Russian (Moldova)',
  'ru-RU': 'Russian (Russia)',
  'ru-UA': 'Russian (Ukraine)',
  rwk: 'Rwa',
  'rwk-TZ': 'Rwa (Tanzania)',
  saq: 'Samburu',
  'saq-KE': 'Samburu (Kenya)',
  sg: 'Sango',
  'sg-CF': 'Sango (Central African Republic)',
  sbp: 'Sangu',
  'sbp-TZ': 'Sangu (Tanzania)',
  seh: 'Sena',
  'seh-MZ': 'Sena (Mozambique)',
  sr: 'Serbian',
  'sr-Cyrl': 'Serbian (Cyrillic)',
  'sr-Cyrl-BA': 'Serbian (Cyrillic, Bosnia and Herzegovina)',
  'sr-Cyrl-ME': 'Serbian (Cyrillic, Montenegro)',
  'sr-Cyrl-RS': 'Serbian (Cyrillic, Serbia)',
  'sr-Latn': 'Serbian (Latin)',
  'sr-Latn-BA': 'Serbian (Latin, Bosnia and Herzegovina)',
  'sr-Latn-ME': 'Serbian (Latin, Montenegro)',
  'sr-Latn-RS': 'Serbian (Latin, Serbia)',
  ksb: 'Shambala',
  'ksb-TZ': 'Shambala (Tanzania)',
  sn: 'Shona',
  'sn-ZW': 'Shona (Zimbabwe)',
  ii: 'Sichuan Yi',
  'ii-CN': 'Sichuan Yi (China)',
  si: 'Sinhala',
  'si-LK': 'Sinhala (Sri Lanka)',
  sk: 'Slovak',
  'sk-SK': 'Slovak (Slovakia)',
  sl: 'Slovenian',
  'sl-SI': 'Slovenian (Slovenia)',
  xog: 'Soga',
  'xog-UG': 'Soga (Uganda)',
  so: 'Somali',
  'so-DJ': 'Somali (Djibouti)',
  'so-ET': 'Somali (Ethiopia)',
  'so-KE': 'Somali (Kenya)',
  'so-SO': 'Somali (Somalia)',
  'es-AR': 'Spanish (Argentina)',
  'es-BO': 'Spanish (Bolivia)',
  'es-CL': 'Spanish (Chile)',
  'es-CO': 'Spanish (Colombia)',
  'es-CR': 'Spanish (Costa Rica)',
  'es-DO': 'Spanish (Dominican Republic)',
  'es-EC': 'Spanish (Ecuador)',
  'es-SV': 'Spanish (El Salvador)',
  'es-GQ': 'Spanish (Equatorial Guinea)',
  'es-GT': 'Spanish (Guatemala)',
  'es-HN': 'Spanish (Honduras)',
  'es-419': 'Spanish (Latin America)',
  'es-MX': 'Spanish (Mexico)',
  'es-NI': 'Spanish (Nicaragua)',
  'es-PA': 'Spanish (Panama)',
  'es-PY': 'Spanish (Paraguay)',
  'es-PE': 'Spanish (Peru)',
  'es-PR': 'Spanish (Puerto Rico)',
  'es-ES': 'Spanish (Spain)',
  'es-US': 'Spanish (United States)',
  'es-UY': 'Spanish (Uruguay)',
  'es-VE': 'Spanish (Venezuela)',
  sw: 'Swahili',
  'sw-KE': 'Swahili (Kenya)',
  'sw-TZ': 'Swahili (Tanzania)',
  sv: 'Swedish',
  'sv-FI': 'Swedish (Finland)',
  'sv-SE': 'Swedish (Sweden)',
  gsw: 'Swiss German',
  'gsw-CH': 'Swiss German (Switzerland)',
  shi: 'Tachelhit',
  'shi-Latn': 'Tachelhit (Latin)',
  'shi-Latn-MA': 'Tachelhit (Latin, Morocco)',
  'shi-Tfng': 'Tachelhit (Tifinagh)',
  'shi-Tfng-MA': 'Tachelhit (Tifinagh, Morocco)',
  dav: 'Taita',
  'dav-KE': 'Taita (Kenya)',
  ta: 'Tamil',
  'ta-IN': 'Tamil (India)',
  'ta-LK': 'Tamil (Sri Lanka)',
  twq: 'Tasawaq',
  'twq-NE': 'Tasawaq (Niger)',
  'te-IN': 'Telugu (India)',
  teo: 'Teso',
  'teo-KE': 'Teso (Kenya)',
  'teo-UG': 'Teso (Uganda)',
  'th-TH': 'Thai (Thailand)',
  bo: 'Tibetan',
  'bo-CN': 'Tibetan (China)',
  'bo-IN': 'Tibetan (India)',
  ti: 'Tigrinya',
  'ti-ER': 'Tigrinya (Eritrea)',
  'ti-ET': 'Tigrinya (Ethiopia)',
  to: 'Tongan',
  'to-TO': 'Tongan (Tonga)',
  'tr-TR': 'Turkish (Turkey)',
  uk: 'Ukrainian',
  'uk-UA': 'Ukrainian (Ukraine)',
  'ur-IN': 'Urdu (India)',
  'ur-PK': 'Urdu (Pakistan)',
  uz: 'Uzbek',
  'uz-Arab': 'Uzbek (Arabic)',
  'uz-Arab-AF': 'Uzbek (Arabic, Afghanistan)',
  'uz-Cyrl': 'Uzbek (Cyrillic)',
  'uz-Cyrl-UZ': 'Uzbek (Cyrillic, Uzbekistan)',
  'uz-Latn': 'Uzbek (Latin)',
  'uz-Latn-UZ': 'Uzbek (Latin, Uzbekistan)',
  vai: 'Vai',
  'vai-Latn': 'Vai (Latin)',
  'vai-Latn-LR': 'Vai (Latin, Liberia)',
  'vai-Vaii': 'Vai (Vai)',
  'vai-Vaii-LR': 'Vai (Vai, Liberia)',
  'vi-VN': 'Vietnamese (Vietnam)',
  vun: 'Vunjo',
  'vun-TZ': 'Vunjo (Tanzania)',
  cy: 'Welsh',
  'cy-GB': 'Welsh (United Kingdom)',
  yav: 'Yangben',
  'yav-CM': 'Yangben (Cameroon)',
  yo: 'Yoruba',
  'yo-NG': 'Yoruba (Nigeria)',
  dje: 'Zarma',
  'dje-NE': 'Zarma (Niger)',
  zu: 'Zulu',
  'zu-ZA': 'Zulu (South Africa)',
  aa: 'Afar',
  ce: 'Chechen',
  ky: 'Kirghiz',
  mi: 'Maori',
  no: 'Norwegian',
  ug: 'Uighur',
  wa: 'Walloon',
}
